/**
 * Use this function to defer making translation keys in Crowdin until the end of
 * the development cycle of a feature.
 *
 * Example workflow:
 * 1) Add a new `TranslationDomain` - use a clear name describing the feature you're working on
 * 2) Start using `needsTranslations` to wrap user-facing text.
 * 3) Feature is eventually done
 * 4) Replace all usages of `needsTranslations` that uses your feature's scope with
 *    translation keys in Crowdin
 *
 * @param domain
 * A "key" identifying the domain / scope in which your text belongs.
 * It's purpose is to make it easy to identify and translate all texts with in the domain / scope.
 *
 * @param text
 * The text that'll be displayed to the user.
 */
export const needsTranslations = (domain: TranslationDomain, text: string) => {
    return text;
};

export type TranslationDomain =
    | 'FinanceOnboardingFreeUs'
    | 'GenericReportFilters'
    | 'GetHelpWithFinances'
    | 'GetHelpWithFamlyPay'
    | 'LearningFrameworkToggles'
    | 'ReferenceMaterialToggles'
    | 'SettingConfigs'
    | 'BillPayer'
    | 'HardDelete'
    | 'FamlyStorePackagePricingPage'
    | 'ImmunizationOnboarding'
    | 'AddNewSiteModal'
    | 'SignupTrialFlow'
    | 'FamlyHomeCategoryOnboarding'
    | 'InternalPayments'
    | 'TestChildActions'
    | 'FamlyStore'
    | 'FamlyPay'
    | 'LandingPages'
    | 'WatchMeGrow'
    | 'SidekickTrial'
    | 'AddonPurchase'
    | 'Village'
    | 'SidekickLearningBundle'
    | 'SimplifiedUsBilling';
